import React from 'react';
import TaskCardContainer from '../../TaskCardContainer';
import TaskFrame1353 from '../../TaskFrame1353';
import {
  SubtitleCon,
  TitleAndFilterContainer,
  TitleAndSubtitleContainer,
} from '../../TasksDesktop/style';


import {
  Frame1354,
  Frame1358,
  Frame1359,
  Frame1360,
  Frame1361,
  TaskScreenMainContainer,
  TeacherTasksEmptyState,
} from './style';
import ImprovedSecondarySideBar from '../../ImprovedSecondarySideBar';
import SharedWithMeLink from '../../../components2/SharedWithMeLink';
function TeacherTasksDesktop(props) {
  const {
    drafts,
    awaitingSubmissions,
    feedbacks,
    showDeletePopuphandler,
    showClosePopupHandler,
    showDateExtendPopuphandler,
    showSchedulePublishPopupHandler,
    showAssignmentStatusPopupHandler,
    onUploadResponses,
    FilterSortAndCal,
    tasksSelected,
    isShowMenu,
    setShowMenu,
    MyCalendarFile,
    assignmentIdForDuplicate,
    classData,
    hasNoCurrentTasks,
    hasClosedTasks,
    onCreateTask,
  } = props;

  const firstNonEmptyColumn = drafts.length > 0 ? 'drafts' : (awaitingSubmissions.length > 0 ? 'awaitingSubmissions' : (feedbacks.length > 0 ? 'feedbacks' : 'none'));

  return (
    <TaskScreenMainContainer>
      <ImprovedSecondarySideBar
        isShowMenu={isShowMenu}
        setShowMenu={setShowMenu}
      />
      <Frame1361>
        <TitleAndFilterContainer>
          <>{FilterSortAndCal}</>
          <SharedWithMeLink
            resourceTypes={['TASK']}
            link="#/sharedtasks"
          />
        </TitleAndFilterContainer>
        <Frame1360>
          {tasksSelected ? (
            <>
              <Frame1359>

                <Frame1354>
                  <TaskFrame1353 outstanding="In Draft" number={drafts.length} />
                  <TaskCardContainer
                    allTasks={drafts}
                    classData={classData}
                    isFirstContainer={firstNonEmptyColumn === 'drafts'}
                    showDeletePopuphandler={showDeletePopuphandler}
                    showDateExtendPopuphandler={showDateExtendPopuphandler}
                    assignmentIdForDuplicate={assignmentIdForDuplicate}
                    showSchedulePublishPopupHandler={showSchedulePublishPopupHandler}
                    showAssignmentStatusPopupHandler={showAssignmentStatusPopupHandler}
                    onUploadResponses={onUploadResponses}
                  />
                </Frame1354>

                <Frame1354>
                  <TaskFrame1353
                    outstanding="Assigned"
                    number={awaitingSubmissions.length}
                  />
                  <TaskCardContainer
                    allTasks={awaitingSubmissions}
                    classData={classData}
                    isFirstContainer={firstNonEmptyColumn === 'awaitingSubmissions'}
                    showDeletePopuphandler={showDeletePopuphandler}
                    showClosePopupHandler={showClosePopupHandler}
                    showDateExtendPopuphandler={showDateExtendPopuphandler}
                    assignmentIdForDuplicate={assignmentIdForDuplicate}
                    showSchedulePublishPopupHandler={showSchedulePublishPopupHandler}
                    showAssignmentStatusPopupHandler={showAssignmentStatusPopupHandler}
                    onUploadResponses={onUploadResponses}
                  />
                </Frame1354>

                <Frame1354>
                  <TaskFrame1353
                    outstanding="In Review"
                    number={feedbacks.length}
                  />
                  <TaskCardContainer
                    allTasks={feedbacks}
                    classData={classData}
                    isFirstContainer={firstNonEmptyColumn === 'feedbacks'}
                    showDeletePopuphandler={showDeletePopuphandler}
                    showClosePopupHandler={showClosePopupHandler}
                    showDateExtendPopuphandler={showDateExtendPopuphandler}
                    assignmentIdForDuplicate={assignmentIdForDuplicate}
                    showSchedulePublishPopupHandler={showSchedulePublishPopupHandler}
                    showAssignmentStatusPopupHandler={showAssignmentStatusPopupHandler}
                    onUploadResponses={onUploadResponses}
                  />
                </Frame1354>
                {hasNoCurrentTasks && (
                  <TeacherTasksEmptyState
                    message={
                      hasClosedTasks
                        ? 'You have no current tasks'
                        : 'No tasks have been created yet'
                    }
                    onCreateTask={onCreateTask}
                  />
                )}
              </Frame1359>
            </>
          ) : (
            MyCalendarFile
          )}
        </Frame1360>
      </Frame1361>
    </TaskScreenMainContainer>
  );
}

export default TeacherTasksDesktop;
